/**
 * UsersTable Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

import { makeSelectQuantityForecastValue } from '../../../../services/quantityForecasts/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectInitialValues = createDeepEqualSelector(
    [
        makeSelectQuantityForecastValue('value'),
        makeSelectQuantityForecastValue('size')
    ],
    (value, size, entityId) => ({
        value,
        size
    })
);

export { selectInitialValues };
